  <template>
    <div>
      <b-card>
      <Table :title="title"
             :actionButton="{ text: 'export' }"
             @actionButtonTab="exportCompanies"
             :fields="fields"
             :url="url"
             :updateData="updateTrigger"
             :showSearch="true"
             :updateFields="role"
             :key="type"
             ref="companiesTable"
             :show-dropdown="true"
             :dropdown-options="filterOptions"
             :dropdown-param-name="'status'"
             :dropdown-value.sync="filterStatus"
      >
        <template #cell(id)="data">
          <b-link :style="{
            width: '65px',
            pointerEvents: adminType(['super_admin', 'admin_type_a']) ? 'auto' : 'none',
          }"
            class="badge badge-light-primary"
            v-if="
              data.item.main_contact_person &&
              data.item.main_contact_person[0] &&
              data.item.main_contact_person[0].user
            "
            :to="role === 'buyer' ? '/investor/' + data.item.main_contact_person[0].user.id : null"
          >
            <span>{{ data.item.main_contact_person[0].user.id }}</span>
          </b-link>
          <span v-else>-</span>
        </template>
        <template #cell(created_at)="data">
          {{ data.item.created_at | formatDate }}
        </template>
        <template #cell(name)="data">
          <b-link
            v-if="
              data.item.main_contact_person &&
              data.item.main_contact_person[0] &&
              data.item.main_contact_person[0].user
            "
            :to="'/investor/' + data.item.main_contact_person[0].user.id"
          >
            <span
              >{{ data.item.main_contact_person[0].user.name }}
              {{ data.item.main_contact_person[0].user.last_name }}
            </span>
          </b-link>
          <span v-else>-</span>
        </template>
        <template #cell(email)="data">
          <span
            v-if="
              data.item.main_contact_person &&
              data.item.main_contact_person[0] &&
              data.item.main_contact_person[0].user
            "
            >{{ data.item.main_contact_person[0].user.email }}
          </span>
        </template>
        <template #cell(company_name)="data">
          <span style="width:55px;" class="badge badge-light-primary"
            v-if="
              data.item.main_contact_person &&
              data.item.main_contact_person[0] &&
              data.item.main_contact_person[0].user
            "
            >C-{{ data.item.main_contact_person[0].company_id }}</span
          >
          <span v-else>-</span>
        </template>

        <template #cell(status)="data">
          <span v-if="data.item && data.item.status == 1" class="text-success"
            >{{ $t("active") }}
          </span>
          <span v-else>{{ $t("inactive") }} </span>
        </template>

        <template #cell(address)="data">
          {{ data.item.address_nr }}, {{ data.item.city }}
        </template>

        <template v-if="role === 'seller'" #cell(address)="data">
          {{ data.item.address_nr }}, {{ data.item.city }}
        </template>

        <template v-if="role === 'seller'" #cell(address)="data">
          {{ data.item.address_nr }}, {{ data.item.city }}
        </template>

        <template #cell(actions)="data">
          <b-button class="action-button" @click="()=>{
            selectedItem = data.item;
            showModal = true;
          }">
            {{ $t("show_balance") }}
          </b-button>
        </template>
      </Table>
      </b-card>

      <BalanceModal @format="amountFormat"  :data="selectedItem" v-if="role === 'buyer' && showModal" :isVisible.sync="showModal" />
      <BalanceSellerModal @format="amountFormat"  :data="selectedItem" v-if="role === 'seller' && showModal" :isVisible.sync="showModal" />
    </div>
  </template>

  <script>
  import {
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BPagination,
    BTr,
    BTh,
    BButton,
    BLink,
    BFormRadioGroup
  } from "bootstrap-vue";
  import ApproveModal from "@/components/Common/ApproveModal";
  import CustomLoader from "@/components/Common/CustomLoader";
  import Table from "@/components/Common/Table2";
  import ScoringStatus from "@/components/Company/ScoringStatus";
  import {CurrencyAmountFormat} from '@core/utils/CurrencyAmountFormat';
  import BalanceModal from "@/components/Common/BalanceModal.vue";
  import BalanceSellerModal from "@/components/Common/BalanceSellerModal.vue";

  export default {
    name: "CompaniesList",
    components: {
      BalanceModal,
      BalanceSellerModal,
      ScoringStatus,
      ApproveModal,
      Table,
      BTable,
      BRow,
      BCol,
      BFormGroup,
      BFormInput,
      BPagination,
      BTr,
      BTh,
      BButton,
      BLink,
      CustomLoader,
    },
    props: ['type'],
    data() {
      return {
        selectedItem: null,
        showModal: false,
        modalText: "",
        modalTitle: "",
        options: null,
        commonFields: [
          {
            label: "created_at",
            align: "start",
            key: "created_at",
            sortable: true
          },
          { label: "id",
            align: "start",
            key: "id",
            sortable: true,
            value: "id"
          },
          {
            label: "company_id",
            key: "company_name",
            sortable: false,
            company_id: "company_id",
            customSlot: true,
            value: "company_name",
          },
          {
            label: "name",
            align: "start",
            key: "name",
            sortable: true,
            value: "name",
          },
          {
            label: "email",
            align: "start",
            key: "email",
            sortable: true,
            value: "email",
          },
          {
            label: "status",
            key: "status",
            customSlot: true,
            sortable: false,
            value: "status",
          },
          {
            label: "actions",
            key: "actions",
            customSlot: true,
            sortable: false,
          },
        ],
        sellerFields: null,
        items: [],
        search: "",
        page: 1,
        pageCount: 0,
        itemsPerPage: 12,
        status: [],
        isLoading: false,
        totalItems: 0,
        approveModalAction: null,
        updateTable: false,
        filterStatus: [],
        filterOptions: [
          { text: 'All', value: [] },
          { text: 'Active', value: [1] },
          { text: 'Inactive', value: [0, 2] }
        ],
        updateTrigger: 0,
      };
    },
    computed: {
      rows() {
        return this.totalItems;
      },
      title() {
        const titles = {investors: 'investors', sellers: 'sellers' };
        return titles[this.type];
      },
      role(){
        const roles = {investors: 'buyer',sellers: 'seller'};
        return roles[this.type];
      },
      url(){
        const urls = {investors: '/buyer/admin/list' ,sellers: '/company/admin/sellers'};
        return urls[this.type];
      },
      fields() {
        const fieldMap = {
          buyer: this.commonFields,
          seller: this.sellerFields
        };
        return fieldMap[this.role];
      }
    },
    created() {
      const elementsToInsert = [
        {
          label: "count_of_sold_invoices",
          align: "start",
          key: "count_of_sold_invoices",
          sortable: true,
          value: "count_of_sold_invoices",
        },
        {
          label: "count_of_settled_invoices",
          align: "start",
          key: "count_of_settled_invoices",
          sortable: true,
          value: "count_of_settled_invoices",
        },
      ];
      this.sellerFields = structuredClone(this.commonFields);
      this.sellerFields.splice(5, 0, ...elementsToInsert);
    },
    methods: {
      exportCompanies(){
        const today = new Date();
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(today.getDate() - 365);

        this.$http.post(
            "company/admin/export",
            {
              role: this.role,
              status: this.filterStatus,
              search: this.$refs.companiesTable ? this.$refs.companiesTable.filter : ''
            },
            { responseType: 'blob' }
        )
            .then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;

              const contentDisposition = response.headers['content-disposition'];
              let fileName = this.role === 'buyer' ? 'Investors_List.xlsx' : 'Sellers_List.xlsx';// incestors or sellers list
              if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (fileNameMatch.length === 2) fileName = fileNameMatch[1];
              }

              link.setAttribute('download', fileName);
              document.body.appendChild(link);
              link.click();
              link.remove();
            })
            .catch((error) => {
              console.error("Export failed", error);
            });

      },
      amountFormat(amount, currency) {
        return CurrencyAmountFormat(amount, currency)
      },
    },
  };
  </script>

  <style scoped>
  .action-button{
    width: 200px;
  }
  </style>
